import tagListSelectorComponent from './tag-list-selector.component';

const tagListSelectorModule = angular.module('tagListSelector', [
])
  .component('tagListSelector', tagListSelectorComponent)
  .name;

export default tagListSelectorModule;
